import { createAsyncThunk } from "@reduxjs/toolkit";
import type { HistoryReferral } from "@store/slices/loyaltyCoreSlice/loyaltyCoreSlice.types";
import type { RootStoreState } from "@store/types";

import { getUser, LoyaltyApi } from "@jti/rest-api";
import { type CustomerReferralHistoryResponseType } from "@jti/rest-api-types";

export const fetchPointsHistoryReferral = createAsyncThunk<
  HistoryReferral | CustomerReferralHistoryResponseType,
  number,
  {
    state: RootStoreState;
  }
>("loyaltyCore/fetchPointsHistoryReferral", async (perPage: number, { getState }) => {
  const loyaltyApi = LoyaltyApi.init();
  const user = getUser();
  if (user?.uuid && user?.ciam_token && perPage) {
    return loyaltyApi.getReferralHistory(user.uuid, user.ciam_token, perPage);
  }
  const referralHistory = getState().loyaltyCore.historyReferral;
  return referralHistory;
});
